import { formatCurrency } from "src/utils/util";
import { CurrencyCode } from "src/utils/util.types";

type AmountProps = {
  currency: CurrencyCode;
  amount: number;
};

export const Amount = ({ amount, currency }: AmountProps) => {
  return <>{formatCurrency(amount, currency)}</>;
};
